"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalTaskClient = void 0;
const ExternalTaskWorker_1 = require("../ExternalTaskWorker");
class ExternalTaskClient {
    constructor(atlasEngineUrl, identity) {
        this.atlasEngineUrl = atlasEngineUrl;
        this.identity = identity;
    }
    /**
     * Gets the url of the engine that this client is communicating with.
     */
    getEngineUrl() {
        return this.atlasEngineUrl;
    }
    async subscribeToExternalTaskTopic(topic, processingFunction, config) {
        const extendedConfig = { ...config };
        if (!extendedConfig.identity) {
            extendedConfig.identity = this.identity;
        }
        const externalTaskWorker = new ExternalTaskWorker_1.ExternalTaskWorker(this.atlasEngineUrl, topic, processingFunction, extendedConfig);
        return externalTaskWorker;
    }
}
exports.ExternalTaskClient = ExternalTaskClient;
//# sourceMappingURL=ExternalTaskHttpClient.js.map